import { render, staticRenderFns } from "./DepartamentoAdministracion.vue?vue&type=template&id=7b1ed7be&scoped=true"
import script from "./DepartamentoAdministracion.vue?vue&type=script&lang=js"
export * from "./DepartamentoAdministracion.vue?vue&type=script&lang=js"
import style0 from "./DepartamentoAdministracion.vue?vue&type=style&index=0&id=7b1ed7be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1ed7be",
  null
  
)

export default component.exports